<template>
  <path d="M20.2496 5.25L3.74963 5.25001" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9.75 9.75V15.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.25 9.75V15.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.25 2.25H15.75" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M18.7496 5.25V19.5C18.7496 19.6989 18.6706 19.8897 18.53 20.0303C18.3893 20.171 18.1985 20.25 17.9996 20.25H5.99963C5.80072 20.25 5.60996 20.171 5.4693 20.0303C5.32865 19.8897 5.24963 19.6989 5.24963 19.5V5.25" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</template>
